import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Part = makeShortcode("Part");
const Ex = makeShortcode("Ex");
const Tr = makeShortcode("Tr");
const LyricSeparator = makeShortcode("LyricSeparator");
const Block = makeShortcode("Block");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`ある日、幸福な、幻のようなあなたが`}</h1>
    <h4>{`Un dì, felice, eterea`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`"Un di, felice, eterea" - La Traviata by Verdi`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/9GKGk_3LT3M" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Un di felice eterea Netrebko/Villazon 2005. Subtítulos en español.`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/xBm4fX7v8_A" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <Part mdxType="Part">Alfredo</Part>
    <p>
  <Ex m="ある、ひとつの（不定冠詞。英語の a に相当）" mdxType="Ex">Un</Ex> <Ex m="日" mdxType="Ex">dì</Ex>, <Ex m="幸福な" mdxType="Ex">felice</Ex>, <Ex m="天上の、霊妙な" o="etereo" mdxType="Ex">eterea</Ex>, mi <Ex m="ぴかっと光る、急に現れる（遠過去）（主語は省略されているがvoi。2人称複数だが、古くは敬称として単数の「あなた」として使われた）" o="balenare" mdxType="Ex">balenaste</Ex> <Ex m="前に、前方に（古語。 = innanzi）" mdxType="Ex">innante</Ex>,
    </p>
    <Tr mdxType="Tr">ある日、幸福な、幻のようなあなたが、突然私の前に現れました</Tr>
    <p>
  e <Ex m="〜から" mdxType="Ex">da</Ex> <Ex m="その、あの" mdxType="Ex">quel</Ex> dì <Ex m="（形容詞）（di 〜に）震える" mdxType="Ex">tremante</Ex> <Ex m="生きる（遠過去）" o="vivere" mdxType="Ex">vissi</Ex> d'<Ex m="未知の" mdxType="Ex">ignoto</Ex> <Ex m="愛、恋" o="amore" mdxType="Ex">amor</Ex>.
    </p>
    <Tr mdxType="Tr">そしてその日から、私は未知の恋に慄きながら生きてきました</Tr>
    <p>
  <Ex m="このdiは前行のd'ignoto amorのd'と同じく、tremante di 〜 とつながっている" mdxType="Ex">Di</Ex> <Ex m="その、あの" mdxType="Ex">quell'</Ex>amor, quell'amor <Ex m="関係代名詞cheと動詞essereの3人称単数形がつながった形（英語のthat/which isに相当）" mdxType="Ex">ch'è</Ex> <Ex m="鼓動" mdxType="Ex">palpito</Ex> dell'<Ex m="宇宙" mdxType="Ex">universo</Ex>, dell'universo <Ex m="全部の" mdxType="Ex">intero</Ex>,
    </p>
    <Tr mdxType="Tr">全宇宙の鼓動であるあの恋に</Tr>
    <p>
  <Ex m="神秘的な（現在ではmisteriosoと書く）" mdxType="Ex">misterïoso</Ex>, misterïoso, <Ex m="誇り高い" mdxType="Ex">altero</Ex>, <Ex m="十字架（ここでは苦難を意味する）" mdxType="Ex">croce</Ex>, croce e <Ex m="喜び" mdxType="Ex">delizia</Ex>, croce e delizia, delizia al <Ex m="心臓、心（詩語。 = cuore）" o="core" mdxType="Ex">cor</Ex>.
    </p>
    <Tr mdxType="Tr">神秘的で、誇り高い、心にとっては十字架であり喜びでもあるあの恋に</Tr>
    <LyricSeparator mdxType="LyricSeparator" />
    <Part mdxType="Part">Violetta</Part>
    <p>
  Ah, <Ex m="もし〜ならば" mdxType="Ex">se</Ex> <Ex m="このこと、そのこと" mdxType="Ex">ciò</Ex> è <Ex m="本当の、真実の" o="vero" mdxType="Ex">ver</Ex>, <Ex m="私を避ける（命令法）" o="fuggire" mdxType="Ex">fuggitemi</Ex>... <Ex m="ただ〜だけの" mdxType="Ex">solo</Ex> <Ex m="友情" mdxType="Ex">amistade</Ex> <Ex m="私は" mdxType="Ex">io</Ex> v'<Ex m="提供する" o="offrire" mdxType="Ex">offro</Ex>;
    </p>
    <Tr mdxType="Tr">ああ、もしそれが本当なら、私を避けてください… 私は友情だけを差し上げますわ</Tr>
    <p>
  <Ex m="愛する" o="amare" mdxType="Ex">amar</Ex> non <Ex m="知っている" o="sapere" mdxType="Ex">so</Ex>, <Ex m="non ... né …でも…でもない" mdxType="Ex">né</Ex> <Ex m="苦しむ、耐える" o="soffrire" mdxType="Ex">soffro</Ex> un <Ex m="このように、これほど" mdxType="Ex">così</Ex> <Ex m="英雄的な、偉大な" mdxType="Ex">eroico</Ex> <Ex m="愛" mdxType="Ex">amore</Ex>.
    </p>
    <Tr mdxType="Tr">私は愛することを知りませんし、これほどの英雄的な愛には耐えられないのです</Tr>
    <p>
  Io sono <Ex m="率直な、純粋な" o="franco" mdxType="Ex">franca</Ex>, <Ex m="純真な、世間ずれしていない" mdxType="Ex">ingenua</Ex>;
    </p>
    <Tr mdxType="Tr">私は率直で純真な女です</Tr>
    <p>
  <Ex m="他の人（女性形）" o="altro" mdxType="Ex">altra</Ex> <Ex m="探す" o="cercare" mdxType="Ex">cercar</Ex> <Ex m="〜しなければならない" o="dovere" mdxType="Ex">dovete</Ex>;
    </p>
    <Tr mdxType="Tr">あなたは他の女性を探さなければなりません</Tr>
    <p>
  non <Ex m="険しい、困難な" mdxType="Ex">arduo</Ex> <Ex m="見つける、〜だと思う、〜だと分かる（未来）（英語のfindに相当する語）" o="trovare" mdxType="Ex">troverete</Ex> <Ex m="私を忘れる" o="dimenticare" mdxType="Ex">dimenticarmi</Ex> <Ex m="その時は、その場合は" o="allora" mdxType="Ex">allor</Ex>
    </p>
    <Tr mdxType="Tr">そうすれば、私を忘れることは難しいことではないでしょう</Tr>
    <Block mdxType="Block">
      <Part mdxType="Part">Alfredo</Part>
      <p>
  Oh, amore misterïoso, misterïoso altero, 
      </p>
      <p>
  croce, croce e delizia, croce e delizia, delizia al cor, delizia, delizia al cor,
      </p>
      <p>
  ah! ah! croce e delizia al cor!
      </p>
      <Tr mdxType="Tr">おお、神秘的で、誇り高い、心にとっては十字架であり喜びでもある恋！</Tr>
      <Part mdxType="Part">Violetta</Part>
      <p>
Non arduo troverete dimenticarmi allora, dimenticarmi, dimenticarmi allor
      </p>
      <p>
dimenticarmi allor, dimenticarmi allor, dimenticarmi, dimenticar,
      </p>
      <p>
  ah! ah! dimenticarmi allor
      </p>
      <Tr mdxType="Tr">そうすれば、私を忘れることは難しいことではないでしょう</Tr>
    </Block>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/fd83228425d5201e91d7f85b0223141d/8698d/traviata-un-di-felice.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "286.00000000000006%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/fd83228425d5201e91d7f85b0223141d/5a190/traviata-un-di-felice.png",
            "srcSet": ["/static/fd83228425d5201e91d7f85b0223141d/772e8/traviata-un-di-felice.png 200w", "/static/fd83228425d5201e91d7f85b0223141d/e17e5/traviata-un-di-felice.png 400w", "/static/fd83228425d5201e91d7f85b0223141d/5a190/traviata-un-di-felice.png 800w", "/static/fd83228425d5201e91d7f85b0223141d/c1b63/traviata-un-di-felice.png 1200w", "/static/fd83228425d5201e91d7f85b0223141d/8698d/traviata-un-di-felice.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      